import React from 'react';
import styles from './DragAndDropFileUploader.module.scss';
import FilePicker from 'components/shared/FilePicker/FilePicker';
import { Text } from 'components/core';

type Props = {
  referenceTitle: string;
  hasError?: boolean;
  onFileUpload: (file: File) => void;
};

const decodeHTMLEntities = (html: string) => {
  const el = document.createElement('p');
  el.innerHTML = html;
  return el.textContent;
};

export default function DragAndDropFileUploader({
  referenceTitle,
  hasError = false,
  onFileUpload,
}: Props) {
  const handleFileChange = (files: File[]) => {
    if (files.length > 0) {
      onFileUpload(files[0]);
    }
  };

  return (
    <div>
      <FilePicker
        acceptedFileTypes={['.pdf']}
        acceptedMimeTypes={['application/pdf']}
        promptText="Drag and drop PDF to upload"
        subText={decodeHTMLEntities(referenceTitle) || undefined}
        buttonText="Choose a file"
        multiple={false}
        hasError={hasError}
        onChange={handleFileChange}
        errorMessageId="drag-drop-error"
      />
      {hasError && (
        <div className={styles.errorMessage}>
          <Text size="xs" variant="danger" id="drag-drop-error">
            Something went wrong. Try uploading your file again.
          </Text>
        </div>
      )}
    </div>
  );
}
